import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { MODULES, ROUTES } from "shared/config";
import { Loader } from "shared/ui";
import { userStore } from "entities/User/store/userStore";
import { useEffect } from "react";
import { useCompanySwitchStore } from "../../../modules/CompanySwitch/store/useCompanySwitchStore";

const RequireAuthorization = ({
  allowedRoles = [],
  allowedCountries = [],
  checkTravelRequestingAuthorization = false,
}) => {
  const user = userStore((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const selectedCompany = useCompanySwitchStore(
    (state) => state.selectedCompany ?? ""
  );

  useEffect(() => {
    if (
      (location.pathname.includes("credit-cards") &&
        !selectedCompany.available_modules?.data.some(
          (module) => module.name === MODULES.CREDIT_CARDS
        )) ||
      (location.pathname.includes("corporate-cards") &&
        !selectedCompany.available_modules?.data.some(
          (module) => module.name === MODULES.CORPORATE_CARDS
        ))
    ) {
      navigate("/local-admin");
    }
  }, [location, selectedCompany]);

  if (!user?.roles)
    return (
      <Loader
        variant="primary"
        size="md"
        className="position-absolute top-50 vw-100 justify-content-center"
      >
        Loading...
      </Loader>
    );

  return (allowedRoles.length === 0 ||
    user?.roles?.data?.some((userRole) =>
      allowedRoles?.includes(userRole.name)
    )) &&
    (allowedCountries.length === 0 ||
      allowedCountries.includes(user?.country_code)) &&
    (checkTravelRequestingAuthorization
      ? user?.is_travel_request_allowed
      : true) ? (
    <Outlet />
  ) : (
    <Navigate to={ROUTES.unauthorized} state={{ from: location }} replace />
  );
};

export default RequireAuthorization;
